import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card card-custom mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark fs-3" }, "My Bestsellers"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-2 fw-bold fs-5" }, "More than 400+ new members")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "nav nav-pills nav-pills-sm nav-light" }
const _hoisted_6 = { class: "card-body p-0 pb-13 mt-n3" }
const _hoisted_7 = {
  class: "tab-content mt-5",
  id: "myTabTables1"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "kt_tab_pane_1_1",
  role: "tabpanel",
  "aria-labelledby": "kt_tab_pane_1_1"
}
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "mt-5 px-9" }
const _hoisted_12 = { class: "d-flex align-items-center me-2" }
const _hoisted_13 = { class: "symbol symbol-50px symbol-light me-3" }
const _hoisted_14 = { class: "symbol-label" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_17 = { class: "fs-7 text-muted fw-bold mt-1" }
const _hoisted_18 = { class: "bg-light rounded fw-bolder text-gray-600 py-2 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = 'week'))
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link btn btn-active-light btn-color-muted py-2 px-4 fw-bolder me-2", { active: _ctx.show === 'week' }]),
              "data-toggle": "tab"
            }, " Week ", 2)
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = 'month'))
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link btn btn-active-light btn-color-muted py-2 px-4 fw-bolder me-2", { active: _ctx.show === 'month' }]),
              "data-toggle": "tab"
            }, " Month ", 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_apexchart, {
                options: _ctx.chartOptions,
                series: _ctx.statsToShow,
                height: "150",
                type: "area"
              }, null, 8, ["options", "series"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataToShow, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass([{ 'mb-6': i !== _ctx.dataToShow.length - 1 }, "d-flex align-items-center justify-content-between"])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("img", {
                          src: item.svg,
                          alt: "",
                          class: "mw-75"
                        }, null, 8, _hoisted_15)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", _hoisted_16, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.desc), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(item.profit), 1)
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}